<template>

    <div class="dropdown-holder" v-click-outside="onOutsideClick" :class="{ disabled: isDisabled, error: error }">
        <div class="value" @click="toggle(true, $event)">
            <span>
                <slot name="current" :title="title" :option="selectedOption">{{ title }}</slot>
            </span>
            <input type="text" class="input-normal" :placeholder="$t('cms.controls.dropdown.search')" v-if="isSearchable && open" v-model="searchQuery" autocomplete="off"
                   @keydown.down="moveHighlighted(1)" @keydown.up="moveHighlighted(-1)" @keydown.enter.prevent="commitHighlightedItem()"
                   @input="highlightedIndex = 0" v-focus="isSearchable && open" />
            <i class="icon magicon-arrow-down-1" @click="toggle(false, $event)" ref="chevron"></i>
        </div>
        <div class="droplist" v-show="open" v-inside-window="!maxHeight" :style="dropListStyle" ref="droplist">
            <a href="#" v-for="(option, index) in resolvedOptions" :class="{ active: value == option.value, highlighted: highlightedIndex == index }" @click.prevent="updateValue(option)">
                <slot name="option" :option="option">{{ option.label }}</slot>
            </a>
        </div>
    </div>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'
    import find from 'lodash/find'

    import resolveOptions from '@wittignl/js-core/utils/resolveOptions'
    import boolString from '@wittignl/js-core/utils/boolString'

    @Component({

        name: 'search-dropdown',
        props: ['placeholder', 'value', 'options', 'error', 'empty', 'disabled', 'searchable', 'maxHeight', 'dropListWidth']
    })
    export default class extends Vue
    {
        ADD_VALUE = 'ADD_VALUE';

        data(){

            return {
                open: false,
                searchQuery: null,
                highlightedIndex: -1
            }
        }

        created(){

            this.$watch('open', () => {

                if(this.open){

                    this.$nextTick(() => this.scrollToActiveItem());
                }
            });

            this.$watch('searchQuery', () => {
                this.$emit('query-changed', this.searchQuery)
            })
        }

        get resolvedOptions(){

            var options = resolveOptions(this.options);

            if(this.empty && options.length > 0){

                options.unshift({
                    label: this.emptyText,
                    value: null
                });
            }

            return options;
        }

        get emptyText(){

            return boolString(this.empty) ? this.$t('cms.controls.dropdown.empty') : this.empty;
        }

        get isSearchable(){

            return boolString(this.searchable);
        }

        get isDisabled(){

            return boolString(this.disabled);
        }

        get title(){

            const option = this.selectedOption;
            if(!option){
                return this.emptyText || this.placeholder;
            }

            return option.label;
        }

        get selectedOption(){

            if(this.value === null || this.value === undefined){
                return null;
            }

            return find(this.resolvedOptions, { value: this.value }) || null;
        }

        get dropListStyle(){

            return { 'max-height': this.maxHeight ? this.maxHeight + 'px' : '', 'width': this.dropListWidth ? this.dropListWidth + 'px' : '' };
        }

        toggle(fromContainer, $event){

            if(fromContainer === true && this.isSearchable && this.open){
                return;
            }

            if(this.isDisabled){
                return;
            }

            if(fromContainer && $event.target === this.$refs.chevron){
                return;
            }

            this.open = !this.open;
        }

        updateValue(option){

            this.$emit('input', option.value);
            this.open = false;
        }

        commitHighlightedItem(){
            const option = this.resolvedOptions[this.highlightedIndex];
            this.updateValue(option);
        }

        onOutsideClick(){

            this.open = false;
        }

        moveHighlighted(direction){

            this.highlightedIndex = Math.max(Math.min(this.highlightedIndex + direction, this.resolvedOptions.length-1), 0);
        }

        scrollToActiveItem(){

            const $droplist = this.$refs.droplist;
            const $activeItemList = $droplist ? $droplist.getElementsByClassName('active') : [];
            const $activeItem = $activeItemList.length > 0 ? $activeItemList[0] : null;

            if (!$droplist || !$activeItem) {
                return;
            }

            $droplist.scrollTop = Math.max($activeItem.offsetTop - 15, 0);
        }
    }

</script>
